import React, { useEffect, useCallback, useState} from 'react';
import {MACROS_EFFECT} from 'effects/live/constants.js';
import Dropdown from 'react-dropdown';
import {getParametersWithAutomation} from 'parameters/getParametersWithAutomation.js';
import {connect} from 'react-redux';
import {INSTRUMENT_RACK} from 'constants/track-types.js';
import {
    setArrangementBottomMode,
    setArrangementBottomResizing,
    setBottomToolbarOffset,
    setShowAutomation,
    setShowPianoRoll,
    setArrangementBottomHeight,
    setTrackAutomationParameter,
    setTrackAutomationRackDevice,
    setTrackAutomationDevice,
    setTrackAutomationSubDevice,
       } from 'actions/index.js';

import Colors from 'components/Colors.js';
const colors = new Colors();

const AutomationParameterDropdowns = (props) => { 
    let {track, selectedDevice, subDevice, selectedParameter, selectedRackDevice} = props;
    let deviceOptions = track.getTrackType() === INSTRUMENT_RACK ?
        []:
        [
            {value: null, label: "None"},
            {value: track, label: "Track"}
        ];
    let rackOptions = [];
    let subDeviceOptions = [];

    let parametersWithAutomation = getParametersWithAutomation(track);

    /**
     * Device -> Sub Device -> Parameter
     * Rack -> Device -> Sub Device -> Parameter
     */
    const onParameterClicked = useCallback((e, parameter) =>  {
        e.stopPropagation();
        if (props.showAutomation && parameter === selectedParameter) {
            return props.setShowAutomation(false);
        }
        props.setShowAutomation(true);
        props.setTrackAutomationParameter(parameter);
    }, [
        selectedParameter,
        props.setTrackAutomationDevice,
        props.setTrackAutomationRackDevice,
        props.showAutomation
    ]
                                         );

    useEffect(() => {
        if (props.selectedInstrument) {
            onChangeRackDevice(props.selectedInstrument);
        }
    }, [props.selectedInstrument, onChangeRackDevice]);

    useEffect(() => {
        let parameter = selectedParameter;
        if (!parameter) {
            return;
        }
        if (parameter.context.subDevice) {
            // its a rack parameter
            props.setTrackAutomationDevice(
                parameter.context.instrument || parameter.context.effect || parameter.context.midiEffect);
            // was this the right choice?
            // props.setTrackAutomationRackDevice(parameter.context.subDevice);
            props.setTrackAutomationSubDevice(parameter.context.subDevice);
        } else if (parameter.context.midiEffect || parameter.context.effect) {
            props.setTrackAutomationDevice(parameter.context.midiEffect || parameter.context.effect);
        }  else {
            props.setTrackAutomationSubDevice(parameter.context.instrument);
        }
        props.setTrackAutomationParameter(parameter);
    }, [selectedParameter]);


    if (track.getTrackType() === INSTRUMENT_RACK) {
        rackOptions = [
            {label: "None", value: null},
            {label: "Track", value: track},
            ... track.getSubDevices()
        ];
        rackOptions = addMacroDeviceOptions(rackOptions, track);
    }

    if (selectedRackDevice && selectedRackDevice.track) {
        track = selectedRackDevice.track;
    }

    if (track.instrument && track.getTrackType() !== INSTRUMENT_RACK) {
        deviceOptions.push({value: track.instrument, label: "Instrument"});
    }

    deviceOptions = addMacroDeviceOptions(deviceOptions, track);


    if (track.effects) {
        deviceOptions = [
            ... deviceOptions,
            ... track.effects.map(
                x => getDeviceOption(x)),
            ... track.midiEffects.effects.map(
                x => getDeviceOption(x))];
    }

    /*
    for (let i in props.sequencerEngine.lfos) {
        let lfo = props.sequencerEngine.lfos[i].lfo;
        deviceOptions.push({value: lfo, label: lfo.name});
    }
    */

    let parameterOptions = [];
    if (track.effects && selectedDevice && selectedDevice.parameters) {
        if (subDevice && selectedDevice.getSubDevices) {
            if (subDevice.trackNumber !== undefined && subDevice.instrument) {
                subDevice = subDevice.instrument;
            }
            parameterOptions = getParametersForDevice(subDevice, props.isMix)
                .map(x => getParameterOption(x));
        } else {
            parameterOptions = getParametersForDevice(selectedDevice, props.isMix)
                .map(x => getParameterOption(x));
        }

        if (selectedDevice.getSubDevices) {
            subDeviceOptions = selectedDevice.getSubDevices();
        }
   }


    for (let i in parameterOptions) {
        let parameter = parameterOptions[i].value;
        let automations = props.isMix ?
            parameter.mixAutomation.automations :
            parameter.automations;
        if (automations.length > 0) {
            parameterOptions[i].className = "has-automations";
        }
    }

    const onChangeRackDevice = useCallback((value) => {
        console.log("on change rack device =", value);
        props.setTrackAutomationRackDevice(value);
        if (!value) {
            console.log("clearing all this shit");
            props.setTrackAutomationDevice(null);
            props.setTrackAutomationSubDevice(null);
            props.setTrackAutomationParameter(undefined);
            return;
        }

        if (value.macroParameter) {
            props.setTrackAutomationDevice(value);
            return;
        }

        let deviceOptions = getDeviceOptionsForTrack(value.track ? value.track : value);
        let deviceToChoose = deviceOptions[0].value;
        if (selectedDevice) {
            let dev = deviceOptions
                .filter(({value}) => value)
                .find(({value}) =>
                      value.name === selectedDevice.name);
            if (dev) {
                deviceToChoose = dev.value;
            }
        }

        if (!deviceToChoose) {
            deviceToChoose = value;
        }
        props.setTrackAutomationDevice(deviceToChoose);
        let parameters = getParametersForDevice(deviceToChoose, props.isMix);
        if (selectedParameter) {
            let parameterWithName = parameters.find(
                p => p.name === selectedParameter.name);
            if (parameterWithName) {
                props.setTrackAutomationParameter(parameterWithName);
                return;
            }
        }
        props.setTrackAutomationParameter(parameters[0]);
    }, [selectedDevice, selectedParameter]);

    const onChangeDevice = useCallback((value) => {
        props.setTrackAutomationDevice(value);
        if (!value) {
            props.setTrackAutomationDevice(null);
            props.setTrackAutomationSubDevice(null);
            props.setTrackAutomationParameter(undefined);
            return;
        }
        if (value.getSubDevices && value.getSubDevices().length > 0) {
            let subDevice = value.getSubDevices()[0].value;
            props.setTrackAutomationSubDevice(subDevice);
            value = subDevice;
        }
        let parameters = getParametersForDevice(value, props.isMix);
        if (selectedParameter) {
            let parameterWithName = parameters.find(
                p => p.name === selectedParameter.name);
            if (parameterWithName) {
                props.setTrackAutomationParameter(parameterWithName);
                return;
            }
        }
        props.setTrackAutomationParameter(parameters[0]);
    }, [
        selectedParameter,
        props.setTrackAutomationParameter,
        props.setTrackAutomationSubDevice,
        props.setTrackAutomationDevice]);

    const onChangeSubDevice = useCallback((value) => {
        props.setTrackAutomationSubDevice(value);
        let parameters = getParametersForDevice(value, props.isMix);
        if (selectedParameter) {
            let parameterWithName = parameters.find(
                p => p.name === selectedParameter.name);
            if (parameterWithName) {
                props.setTrackAutomationParameter(parameterWithName);
                return;
            }
        }
        props.setTrackAutomationParameter(parameters[0]);
    }, [selectedParameter]);

    const getSubDeviceOption = useCallback((value) => {
        let option = subDeviceOptions.find(opt => opt.value === value);
        return option;
    }, [subDeviceOptions]);

    const automationIcon = props.showAutomation ?
          "/automation-icon-enabled.png" : 
          "/automation-icon-disabled.png";
    let dropdownClassName = props.showAutomation ?
          "dropdowns" : "dropdowns disabled";

    let color = colors.getColorForTrack(props.track);
    let style ={
    };

    if (track.getTrackType() === INSTRUMENT_RACK) {
        if (!selectedRackDevice) {
            dropdownClassName += " non-selected rack-dropdown";
        }
    } else {
        if (!selectedDevice) {
            dropdownClassName += " non-selected";
        }
    }

  return (
      <div className={dropdownClassName}>
        {rackOptions.length > 0 ?
         <Dropdown
           onMouseDown={(e) => e.stopPropagation()}
           options={rackOptions}
           onChange={(o) => onChangeRackDevice(o.value)} 
           value={getDeviceOption(selectedRackDevice, true)}
           placeholder="Rack Device" />
         : ''}
        {selectedRackDevice === track ?
         '' : 
        <Dropdown
          onMouseDown={(e) => e.stopPropagation()}
          controlClassName="device-dropdown"
          options={deviceOptions}
          onChange={(o) => onChangeDevice(o.value)} 
          value={getDeviceOption(selectedDevice)}
          placeholder="Device" />}
        {selectedRackDevice !== track && subDeviceOptions.length > 0 ?
         <Dropdown
          controlClassName="sub-device-dropdown"
           onMouseDown={(e) => e.stopPropagation()}
           options={subDeviceOptions}
           onChange={(o) => onChangeSubDevice(o.value)} 
           value={getSubDeviceOption(subDevice)}
           placeholder="Sub Device" /> : ''}
        <Dropdown
          controlClassName="parameter-dropdown"
          onMouseDown={(e) => e.stopPropagation()}
          options={parameterOptions}
          onChange={(o) => props.setTrackAutomationParameter(o.value)}
          value={getParameterOption(selectedParameter)}
          placeholder="Parameter" />
      </div>);
}

const getDeviceOption = (device, isRack) => device && ({
    label: device.trackNumber !== undefined && !device.instrumentRack ?
        "Track" :
        device.instrumentRack && !isRack ? "Instrument" :
        device.presetName || device.name || (device.getName && device.getName()) ,
    value: device});
const getParameterOption = (parameter) => parameter && ({label: parameter.prettyName, value: parameter});

const getParametersForDevice = (device, isMix=false) => {
    let parameters = device.parameters
        .filter(x => isMix ? x.mixAutomation.automations : x.automations);
    parameters.sort(
        (a,b) => isMix ?
            b.mixAutomation.automations.length - a.mixAutomation.automations.length : 
            b.automations.length - a.automations.length);
    return parameters.filter(
        x =>
            x.automatable &&
            x.uxAutomatable &&
            !x.isMapped &&
            x.name !== 'enabled' && x.name !== 'Configuration');
};

const addMacroDeviceOptions = (deviceOptions, track) => {
    // do we have a macro effect?
    let macrosEffect = track.liveEffects.effects.find(
        e => e.effect === MACROS_EFFECT);

    if (!macrosEffect) {
        return deviceOptions;
    }

    let macroOptions = [];
    for (let i in macrosEffect.macros) {
        let macro = macrosEffect.macros[i];
        if (macro.subMacros.length > 0) {
            macroOptions.push({
                    label: macro.name,
                    value: macro
            });
        }
    }

    return [... deviceOptions, ...macroOptions];
};


const getDeviceOptionsForTrack= (track) => {
    let deviceOptions = [];
    if (track.instrument && track.getTrackType() !== INSTRUMENT_RACK) {
        deviceOptions.push({value: track.instrument, label: track.instrument.name});
    }

    deviceOptions = [
        {label: "None", value: null},
        ... deviceOptions,
        ... track.effects.map(
            x => getDeviceOption(x)),
        ... track.midiEffects.effects.map(
            x => getDeviceOption(x))];

    return deviceOptions;
};

const mapStateToProps = (state, props) => {
    if (props.track) {
        let track = props.track;
        if (track && track.tracks && track.tracks[0]) {
            track = track.tracks[0].track;
        }

        return {
            id: track === undefined ? 0 :
                track.sample !== undefined && track.sample.getId() !== undefined ?
                track.sample.getId() : track.presetName || track.getName(),
            numEffects: props.track.effects && props.track.effects.length,
            selectedDevice: state.automation.trackDevice[props.track.id],
            subDevice: state.automation.trackSubDevice[props.track.id],
            selectedParameter: state.automation.trackParameter[props.track.id],
            showAutomation: state.automation.show,
            selectedRackDevice: state.automation.trackRackDevice[props.track.id],
            selectedInstrument: state.tracks.selectedRackSubTrack[props.track.id],
            bottomMode: state.arrangement.bottomMode
        };
    }
    return {};
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setTrackAutomationParameter: (parameter) =>
            dispatch(setTrackAutomationParameter(props.track.id, parameter)),
        setShowPianoRoll: (show) =>
            dispatch(setShowPianoRoll(show)),
        setTrackAutomationDevice: (device) =>
            dispatch(setTrackAutomationDevice(props.track.id, device)),
        setTrackAutomationRackDevice: (device) =>
            dispatch(setTrackAutomationRackDevice(props.track.id, device)),
        setTrackAutomationSubDevice: (device) =>
            dispatch(setTrackAutomationSubDevice(props.track.id, device)),
        setArrangementBottomResizing: (resizing) =>
            dispatch(setArrangementBottomResizing(resizing)),
        setArrangementBottomHeight: (height) =>
            dispatch(setArrangementBottomHeight(height)),
        setShowAutomation: (show) =>
            dispatch(setShowAutomation(show)),
        setBottomMode: (bottomMode) =>
            dispatch(setArrangementBottomMode(bottomMode)),
        setBottomOffset: (bottomOffset) =>
            dispatch(setBottomToolbarOffset(bottomOffset))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutomationParameterDropdowns);
